var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorState404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5520_217372)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2418 43.0476C49.4976 52.58 41.4242 60.0632 31.5507 64.0484C16.9613 69.9366 4.71364 83.3937 0.82692 104.432C0.400358 106.741 0.394108 109.114 0.821061 111.423C6.85504 144.068 33.0078 158.467 56.8109 154.65C70.141 152.511 83.6359 156.957 93.5164 166.158C113.608 184.866 145.815 190.731 177.08 170.678C180.743 168.328 185.657 163.398 188.004 159.734C214.944 117.675 194.988 73.9081 159.968 60.2589C150.711 56.6507 142.891 50.0675 138.108 41.3597C130.066 26.7167 114.503 16.7902 96.6156 16.7902C78.0496 16.7902 61.9882 27.4843 54.2418 43.0476Z",
    fill: "url(#paint0_linear_5520_217372)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5520_217372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 201
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.501953 0.00050354H200.502V200H0.501953V0.00050354Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5520_217372)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5520_217372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 33,
    width: 157,
    height: 112
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.377 33.0237H178.627V144.059H22.377V33.0237Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5520_217372)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.100006
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.628 38.8824V138.199C178.628 141.433 176.003 144.058 172.769 144.058H28.2373C25.0029 144.058 22.3779 141.433 22.3779 138.199V38.8824C22.3779 35.6484 25.0029 33.023 28.2373 33.023H172.769C176.003 33.023 178.628 35.6484 178.628 38.8824Z",
    fill: "#005B99"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.655 180.662H78.3496L87.2098 145.544H113.795L122.655 180.662Z",
    fill: "#337CAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.88 157.771H84.124L87.2096 145.543H113.795L116.88 157.771Z",
    fill: "#8AB4D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.627 47.0873V146.404C178.627 149.638 176.002 152.263 172.768 152.263H28.2363C25.002 152.263 22.377 149.638 22.377 146.404V47.0873C22.377 43.8529 25.002 41.2279 28.2363 41.2279H172.768C176.002 41.2279 178.627 43.8529 178.627 47.0873Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.381 132.578H51.623V60.0443H149.381V132.578Z",
    fill: "#FFEDEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.627 60.0446V47.0871C178.627 43.8508 176.003 41.2278 172.768 41.2278H28.2363C25.0004 41.2278 22.377 43.8508 22.377 47.0871V60.0446H178.627Z",
    fill: "#337CAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.655 180.662H78.3496L87.2098 145.544H113.795L122.655 180.662Z",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.377 132.578V146.402C22.377 149.638 25.0004 152.262 28.2363 152.262H172.768C176.003 152.262 178.627 149.638 178.627 146.402V132.578H22.377Z",
    fill: "#8AB4D0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8398 180.66H130.163",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.252 50.605V50.6644",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8018 50.605V50.6644",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3496 50.605V50.6644",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M178.627 121.82V47.0864C178.627 43.8504 176.003 41.227 172.768 41.227H28.2363C25.0004 41.227 22.377 43.8504 22.377 47.0864V60.0442H178.627",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.377 70.8025V146.402C22.377 149.638 25.0004 152.262 28.2363 152.262H172.768C176.003 152.262 178.627 149.638 178.627 146.402V132.578H22.377",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7018 72.0446C80.8357 72.0446 79.3225 73.5575 79.3225 75.4239V80.788H75.5221V75.4239C75.5221 73.5575 74.0088 72.0446 72.1424 72.0446C70.276 72.0446 68.7627 73.5575 68.7627 75.4239V84.1673C68.7627 86.0341 70.276 87.547 72.1424 87.547H79.3225V95.3266C79.3225 97.193 80.8357 98.7059 82.7018 98.7059C84.5682 98.7059 86.0814 97.193 86.0814 95.3266V75.4239C86.0814 73.5575 84.5682 72.0446 82.7018 72.0446Z",
    fill: "#F06677"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.86 72.0446C126.994 72.0446 125.481 73.5575 125.481 75.4239V80.788H121.68V75.4239C121.68 73.5575 120.167 72.0446 118.301 72.0446C116.434 72.0446 114.921 73.5575 114.921 75.4239V84.1673C114.921 86.0341 116.434 87.547 118.301 87.547H125.481V95.3266C125.481 97.193 126.994 98.7059 128.86 98.7059C130.726 98.7059 132.24 97.193 132.24 95.3266V75.4239C132.24 73.5575 130.726 72.0446 128.86 72.0446Z",
    fill: "#F06677"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.62 90.9368C103.62 91.6091 103.073 92.1552 102.402 92.1552H98.798C98.1266 92.1552 97.5797 91.6091 97.5797 90.9368V79.813C97.5797 79.1415 98.1266 78.5946 98.798 78.5946H102.402C103.073 78.5946 103.62 79.1415 103.62 79.813V90.9368ZM102.402 71.836H98.798C94.3996 71.836 90.8203 75.4149 90.8203 79.813V90.9368C90.8203 95.3356 94.3996 98.9146 98.798 98.9146H102.402C106.8 98.9146 110.379 95.3356 110.379 90.9368V79.813C110.379 75.4149 106.8 71.836 102.402 71.836Z",
    fill: "#F06677"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M152.057 106.842C150.378 108.522 147.655 108.522 145.977 106.842C147.655 108.522 147.655 111.244 145.977 112.923C147.655 111.244 150.378 111.244 152.057 112.923C150.378 111.244 150.378 108.522 152.057 106.842Z",
    stroke: "#F06677",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.057 92.8341C150.378 94.513 147.655 94.513 145.977 92.8341C147.655 94.513 147.655 97.2353 145.977 98.9142C147.655 97.2353 150.378 97.2353 152.057 98.9142C150.378 97.2353 150.378 94.513 152.057 92.8341Z",
    stroke: "#F06677",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0268 84.8546C53.3475 86.5335 50.6252 86.5335 48.9463 84.8546C50.6252 86.5335 50.6252 89.2562 48.9463 90.9347C50.6252 89.2562 53.3475 89.2562 55.0268 90.9347C53.3475 89.2562 53.3475 86.5335 55.0268 84.8546Z",
    stroke: "#F06677",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0268 70.8453C53.3475 72.5246 50.6252 72.5246 48.9463 70.8453C50.6252 72.5246 50.6252 75.2469 48.9463 76.9254C50.6252 75.2469 53.3475 75.2469 55.0268 76.9254C53.3475 75.2469 53.3475 72.5246 55.0268 70.8453Z",
    stroke: "#F06677",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6623 113.332H127.853C128.959 113.332 129.856 112.435 129.856 111.328C129.856 110.222 128.959 109.325 127.853 109.325H92.6623C91.5561 109.325 90.6592 110.222 90.6592 111.328C90.6592 112.435 91.5561 113.332 92.6623 113.332Z",
    fill: "#F06677"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.152 113.332H82.7637C83.8699 113.332 84.7668 112.435 84.7668 111.328C84.7668 110.222 83.8699 109.325 82.7637 109.325H73.152C72.0453 109.325 71.1484 110.222 71.1484 111.328C71.1484 112.435 72.0453 113.332 73.152 113.332Z",
    fill: "#FFFBE4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M73.152 121.278H127.852C128.958 121.278 129.855 120.382 129.855 119.275C129.855 118.169 128.958 117.272 127.852 117.272H73.152C72.0453 117.272 71.1484 118.169 71.1484 119.275C71.1484 120.382 72.0453 121.278 73.152 121.278Z",
    fill: "#F06677"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.54 27.9277L130.245 23.6331L134.54 19.3382L138.835 23.6331L134.54 27.9277Z",
    stroke: "#337CAD",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3496 177.934L48.0547 173.639L52.3496 169.345L56.6445 173.639L52.3496 177.934Z",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M142.378 169.742L138.083 165.447L142.378 161.152L146.673 165.447L142.378 169.742Z",
    stroke: "#8AB4D0",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M161.84 180.278L157.545 175.983L161.84 171.689L166.135 175.983L161.84 180.278Z",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5520_217372",
    x1: 196.337,
    y1: 172.554,
    x2: 9.89594,
    y2: 214.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEF0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5520_217372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorState404);
export default __webpack_public_path__ + "static/media/error-state-404.58e687a23ac13fe3badc26142f472b1d.svg";
export { ForwardRef as ReactComponent };